import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';

import { Markdown } from '../elements';
import ServiceCard from './ServiceCard';

const AllServices = ({ title }) => {
  const { allSanityServicesPage } = useStaticQuery(graphql`
    {
      allSanityServicesPage {
        nodes {
          _id
          title
          slug {
            current
          }
          description
          logo {
            asset {
              id
              gatsbyImageData(width: 400)
              altText
            }
          }
        }
      }
    }
  `);

  const allServices = allSanityServicesPage.nodes;

  return (
    <section className="section">
      <div className="container">
        {title && (
          <div className="columns is-centered mb-5">
            <div className="column is-8 has-text-centered">
              <Markdown className="pb-2 has-text-grey-dark">{title}</Markdown>
            </div>
          </div>
        )}
        <div className="columns is-multiline">
          {allServices &&
            allServices.map((item) => {
              if (!item) return null;
              return (
                <ServiceCard
                  isLine
                  key={item._id}
                  title={item.title}
                  description={item.description}
                  slug={`/services/${item.slug.current}`}
                  image={item.logo && item.logo.asset.id}
                  alt={item.logo.asset.altText}
                />
              );
            })}
        </div>
      </div>
    </section>
  );
};

export default AllServices;
